/**
 * @description Function for checking the host to match 'banki-ru'.
 * @returns {boolean} Boolean value which corresponds 'banki-ru' host.
 */
export function isBankiRu() {
    return (
        window.location.origin ===
        sessionStorage.getItem('REACT_APP_BANKI_RU_URL')
    );
}
